




import { Component, Vue } from 'vue-property-decorator';
import { store } from '@/store';
import { readHasDistributorAccess } from '@/store/main/getters';

const routeGuardAdmin = async (to, from, next) => {
  if (!readHasDistributorAccess(store)) {
    next('/main');
  } else {
    next();
  }
};

@Component
export default class ContractAdmin extends Vue {
  public beforeRouteEnter(to, from, next) {
    routeGuardAdmin(to, from, next);
  }

  public beforeRouteUpdate(to, from, next) {
    routeGuardAdmin(to, from, next);
  }
}
